import styled, { css } from "styled-components";

import { Input as SitesparkInput } from "@racepointenergy/gatsby-theme-sitespark/src/components/Html";

import { Header2 } from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import {
  getFontFamily,
  getSize,
  hexToRgba,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

export const baseFactory = base => inputName => base + "" + inputName;

export const sectionPaddingCss = css`
  background-color: ${({
    theme: {
      colors: { mayAsWellBeWhite },
    },
  }) => hexToRgba(mayAsWellBeWhite, 0.9)};
  padding: 0px 0px 35px 0px;
  @media screen and (min-width: ${getSize("mobile480")}) {
    padding: 38px 0px 40px 0px;
  }
  @media screen and (min-width: ${getSize("tablet720")}) {
    padding: 50px 0px;
  }
  /* @media screen and (min-width: ${getSize("tablet768")}) {} */
  @media screen and (min-width: ${getSize("tablet960")}) {
    padding: 56px 0px;
  }
  @media screen and (min-width: ${getSize("desktop1200")}) {
    padding: 56px 0px;
  }
  @media screen and (min-width: ${getSize("desktop1920")}) {
    padding: 28px 0px 18px 0px;
  }
`;

export const sectionViewCss = css`
  align-items: stretch;
  display: flex;
  flex-flow: row nowrap;
  list-style: none;
  margin: 0 auto;

  overflow-x: auto;
  padding: 0;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;

  max-width: calc(100vw - 76px);
  @media screen and (min-width: ${getSize("mobile480")}) {
    max-width: calc(100vw - 92px);
  }
  @media screen and (min-width: ${getSize("tablet720")}) {
    max-width: 620px;
  }
  @media screen and (min-width: ${getSize("tablet768")}) {
    max-width: 720px;
  }
  @media screen and (min-width: ${getSize("tablet960")}) {
    max-width: calc(100vw - 80px);
  }
  @media screen and (min-width: ${getSize("desktop1200")}) {
    max-width: 525px;
  }
  @media screen and (min-width: ${getSize("desktop1920")}) {
    max-width: 740px;
  }

  ${({ jsDisabled }) =>
    jsDisabled
      ? ""
      : `
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE 10+ */
        ::-webkit-scrollbar {
          display: none; /* Chrome Safari */
        `}
`;

export const Input = styled(SitesparkInput)`
  @media screen and (min-width: ${getSize(
      "tablet960"
    )}) and (max-width: 1199px) {
    font-size: 20px;
    padding: 14px 24px 13px 24px;
  }
  @media screen and (min-width: ${getSize("desktop1200")}) {
    padding: 8px 17px 8px 17px;
  }
  @media screen and (min-width: ${getSize("desktop1920")}) {
    font-size: 20px;
    padding: 14px 24px 13px 24px;
  }
`;

export const Range = styled(SitesparkInput)`
  margin: 10px 1em 0px calc(16px + 1em);
  max-width: 400px;
`;

export const RangeLabel = styled.label`
  color: ${({
    theme: {
      colors: { silver },
    },
  }) => silver};
  margin: 0px 1em 0px calc(16px + 1em);
  max-width: 400px;
  text-align: center;
`;

export const FormPartial = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-row-gap: 10px;
  grid-template-columns: 295px;
  grid-template-rows: auto;
  justify-content: center;
  justify-items: stretch;
  list-style: none;
  @media screen and (min-width: ${getSize("mobile480")}) {
    grid-template-columns: 387px;
  }
  @media screen and (min-width: ${getSize("tablet720")}) {
    grid-template-columns: 525px;
  }
  @media screen and (min-width: ${getSize("tablet960")}) {
    grid-template-columns: 740px;
  }
  @media screen and (min-width: ${getSize("desktop1200")}) {
    grid-template-columns: 525px;
  }
  @media screen and (min-width: ${getSize("desktop1920")}) {
    grid-template-columns: 740px;
  }
`;

export const Section = styled.li`
  scroll-snap-align: center start;
  flex: 1 0 100%;
  list-style: none;
  padding: 0 0 44px 0;
  position: relative;
  margin: 0;

  align-content: center;
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: auto;
  grid-template-columns: auto;

  @media screen and (min-width: ${getSize("desktop1920")}) {
    padding: 18px 0 72px 0;
  }
`;

export const Title = styled(Header2)`
  text-align: center;
`;

export const StyledP2 = styled.p`
  color: ${({
    theme: {
      colors: { grey },
    },
  }) => grey};
  font-size: 16px;
  line-height: 24px;
  margin: 16px auto 26px auto;
  max-width: 720px;
  text-align: center;
  @media screen and (min-width: ${getSize("tablet720")}) {
    font-size: 20px;
    letter-spacing: 0px;
    line-height: 31px;
  }
  @media screen and (min-width: ${getSize("desktop1200")}) {
    font-size: 17px;
    line-height: 27px;
  }
  @media screen and (min-width: ${getSize("desktop1920")}) {
    font-size: 20px;
    line-height: 31px;
    margin: 10px auto 20px auto;
  }
  ${getFontFamily("regular")}
`;

export const Checkboxes = styled.div`
  display: grid;
  grid-auto-rows: auto;
  justify-content: center;
  padding: 16px 0px;
  > label {
    padding: 4px 0px;
  }
  @media screen and (min-width: ${getSize("tablet720")}) {
    grid-template-columns: auto auto;
    grid-column-gap: 52px;
    grid-row-gap: 12px;
  }
  @media screen and (min-width: ${getSize("desktop1920")}) {
    padding: 16px 0px 8px 0px;
  }
`;

export const MergedGridRow = styled.div`
  display: contents;
  @media screen and (min-width: ${getSize("tablet720")}) {
    display: grid;
    grid-column-gap: 6px;
  }
`;
